import "regenerator-runtime/runtime";

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(checkWinbackOfferPermissionSaga);

import { call, select } from 'redux-saga/effects';
import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import { isLoggedIn } from 'redux/saga/selectors';
import { userProfile, userInactivePermissions } from 'redux/saga/entities/bound'; // redirects users depending on eligibility for winback offers

export function checkWinbackOfferPermissionSaga(client, replaceState, isAllowedTo, notAllowedTo) {
  var profile, permissions;
  return regeneratorRuntime.wrap(function checkWinbackOfferPermissionSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return select(isLoggedIn);

        case 2:
          if (!_context.sent) {
            _context.next = 22;
            break;
          }

          _context.next = 5;
          return call(fetchEntityIfNeeded, userProfile, [client]);

        case 5:
          profile = _context.sent;
          _context.next = 8;
          return call(fetchEntityIfNeeded, userInactivePermissions, [client, profile.id]);

        case 8:
          permissions = _context.sent;

          if (!permissions.disallow_winback_offers) {
            _context.next = 16;
            break;
          }

          _context.t0 = notAllowedTo;

          if (!_context.t0) {
            _context.next = 15;
            break;
          }

          _context.next = 14;
          return call(replaceState, notAllowedTo);

        case 14:
          _context.t0 = _context.sent;

        case 15:
          return _context.abrupt("return", _context.t0);

        case 16:
          _context.t1 = isAllowedTo;

          if (!_context.t1) {
            _context.next = 21;
            break;
          }

          _context.next = 20;
          return call(replaceState, isAllowedTo);

        case 20:
          _context.t1 = _context.sent;

        case 21:
          return _context.abrupt("return", _context.t1);

        case 22:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}